import { rules, timeline } from "../data";
import SectionHeading from "./SectionHeading";

export default function RulesSection() {
  return (
    <section id="rules" className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14">
          <div className="lg:col-span-2">
            <SectionHeading
              light
              eyebrow="Rules & regulation"
              title="赛制规则说明"
              desc="规则写得越清楚，参赛就越省心。下面四条覆盖了作品形式、内容红线、提交修改与结果判定，读一遍基本就能开工。"
            />

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {rules.map((group) => (
                <article
                  key={group.title}
                  className="p-5 rounded-lg bg-foreground-900 border border-foreground-800"
                >
                  <h3 className="font-heading text-base md:text-lg font-bold text-accent-400">
                    {group.title}
                  </h3>
                  <ul className="mt-3 flex flex-col gap-2.5">
                    {group.items.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-background-200 leading-relaxed">
                        <i className="ri-checkbox-blank-circle-fill text-[6px] mt-2 text-primary-400 shrink-0" aria-hidden="true"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-1">
            <div className="p-5 md:p-6 rounded-lg bg-background-50 text-foreground-950">
              <h3 className="font-heading text-lg font-bold flex items-center gap-2">
                <i className="ri-calendar-schedule-line text-primary-600" aria-hidden="true"></i>
                赛季时间线
              </h3>
              <ol className="mt-5 flex flex-col">
                {timeline.map((item, index) => (
                  <li key={item.title} className="relative pl-6 pb-5 last:pb-0">
                    {index !== timeline.length - 1 && (
                      <span className="absolute left-[5px] top-3 bottom-0 w-px bg-background-200" />
                    )}
                    <span className="absolute left-0 top-1.5 w-[11px] h-[11px] rounded-full bg-accent-500 ring-4 ring-accent-100" />
                    <p className="text-xs font-label tracking-wide text-primary-600">{item.date}</p>
                    <p className="mt-1 text-sm font-bold text-foreground-950">{item.title}</p>
                    <p className="mt-0.5 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mt-5 p-5 rounded-lg bg-primary-950 border border-primary-900">
              <h4 className="text-sm font-bold text-accent-400 flex items-center gap-2">
                <i className="ri-alert-line" aria-hidden="true"></i>
                一条不能碰的线
              </h4>
              <p className="mt-2 text-xs text-primary-100 leading-relaxed">
                任何涉及他人真实姓名、隐私信息或攻击性内容的作品，都将在初审阶段被直接退回。我们只比谁更会自嘲。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}